<!-- Start -->

<ion-grid *ngIf="data?.journal?.length == 0">
  <ion-list>
    <div class="start">
      <div class="title">{{ capacitor.translateString('StartJournal') }}</div>
      <div class="text">{{ capacitor.translateString('StartJournalText') }}</div>
      <div class="buttons">
        <ion-button mode="ios" class="primary" (click)="openManage('post')">
          <ion-label>{{ capacitor.translateString('StartPost') }}</ion-label>
        </ion-button>
      </div>
    </div>
  </ion-list>
</ion-grid>

<!-- Posts -->

<ion-grid *ngIf="data?.journal?.length != 0">
  <app-header title="Friends" type="friends"></app-header>
  <ion-skeleton-text *ngIf="!data?.journal" animated></ion-skeleton-text>
  <ion-list>
    <app-item [data]="data" type="posts" *ngFor="let data of journal"></app-item>
  </ion-list>
</ion-grid>

<!-- Infinite -->

<ion-infinite-scroll (ionInfinite)="doInfinite($event)" *ngIf="journal && data?.journal?.length >= 50">
  <ion-infinite-scroll-content></ion-infinite-scroll-content>
</ion-infinite-scroll>
